import React from 'react';

const LoaderStep = () => {
  return (
    <div className="tw-w-100 tw-h-full tw-bg-transparent tw-flex tw-items-center tw-justify-center tw-z-50"></div>
  );
};

export default LoaderStep;
